/**
 * 스탠드얼론 새 버전 확인 — 켜질 때 한 번, 그 뒤 6시간마다(2026-10-03).
 * 알림만 한다(backend/modules/common/updateCheck.js 머리말). 실패는 조용히 — 오프라인 PC 에서 매번 오류를 띄우면 안 된다.
 * `check()` 는 메뉴의 「업데이트 확인」이 부른다 — 그때는 결과(최신입니다/새 판/실패)를 돌려준다.
 */
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import buildInfo from '../build-info.json';

const API_ROOT = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/sql-developer\/?$/, '');
const POLL_MS = 6 * 60 * 60 * 1000;

export async function fetchUpdateInfo() {
    const r = await axios.get(`${API_ROOT}/sql-developer/update-check`, { params: { current: buildInfo.version }, timeout: 8000 });
    return r.data;
}

export default function useUpdateCheck(active) {
    const [info, setInfo] = useState(null);
    const check = useCallback(async () => {
        const r = await fetchUpdateInfo();
        setInfo(r);
        return r;
    }, []);
    useEffect(() => {
        if (!active) { setInfo(null); return undefined; }
        let alive = true;
        let timer = null;
        const tick = async () => {
            try { const r = await fetchUpdateInfo(); if (alive) setInfo(r); } catch (_e) { /* 오프라인·서버 없음 — 조용히 */ }
            if (alive) timer = setTimeout(tick, POLL_MS);
        };
        tick();
        return () => { alive = false; clearTimeout(timer); };
    }, [active]);
    return { info, check };
}
